export default __webpack_public_path__ + "static/media/bg_4.3d2a4a4a.png";